import React, { Component } from 'react'
import FixedView from '../FixedView'
// import Collapsible from 'react-collapsible'
import { checkTranslation, translate } from '../../utils/useful'
import IntractionActionsList from '../IntractionActionsList';
import StagesManager from '../StagesManager';
import Modal from '../Modal';
import TextInput from '../inputs/TextInput';
import ButtonAnimated from '../buttons/ButtonAnimated';
import HttpServices from '../../utils/Http.services';
import importedIcons from '../inputs/icons';
import { framesType } from '../../variables/framesTypes';
import store from '../../stores/storeConfig';
import { addNotif } from '../../stores/actionsList';
// import { Modal } from 'react-bootstrap';

export default class FramesPlusBut extends Component {
    state = {
        collapses: {},
        name: ''
    }

    componentDidMount() {
        setTimeout(() => {
            this.setState({ show: true })
        }, 10);
    }


    newFrame = (type, mode) => {
        this.plusFixedView.hideView()
        this.setState({ type, mode }, () => {
            // console.log('functionsHandler2', this.props.functionsHandler)
            if (this.props.functionsHandler) {
                this.props.functionsHandler(null, 'changePage', ['settings', 'frames', 'new'], { parent: this.props.frame, type: this.state.type, mode: this.state.mode })
            }

        })
    }


    openNameModal = (type, mode) => {
        this.plusFixedView.hideView()
        this.setState({ type, mode }, () => {
            this.addModal.showModal()
            setTimeout(() => {
                if (this.nameInput) {
                    this.nameInput.focus()
                }
            }, 10);

        })
    }

    addClicked = () => {
        if (this.state.name != '') {

            // console.log('addClicked', this.props.frame)
            let data = {}
            data.frame = this.props.frame
            data.name = this.state.name
            data.type = this.state.type
            data.mode = this.state.mode
            this.saveData(data, () => {
                this.setState({ name: '' })
                this.addModal.hideModal()
            })
        }

    }


    saveData = (data, cb) => {

        // console.log(data)
        //todo
        data.applet = this.props.variables
        // console.log('this.props.variables', this.props.variables)
        let info = framesType[data.type]
        if (info) {
            Object.entries(info.postBody)?.map(([key, value]) => {
                data[key] = value
                if (typeof value == 'string' && value.startsWith('{{')) {
                    let baseValue = value.replace(/{/g, '').replace(/}/g, '')
                    data[key] = this.props.variables[baseValue]
                }
            })

            data.parent = this.props.frame
            // console.log('info.addUrl', info.addUrl)
            // console.log('data', data)
            HttpServices.request(info.addUrl, data, (fetchResult, fetchError) => {
                if (fetchError) {
                    store.dispatch(addNotif({ type: 'error', title: '{{lang}}errors.updateFailed', description: fetchError.message }))
                    return
                }
                store.dispatch(addNotif({ type: 'success', title: '{{lang}}info.createdSuccesfully', description: '{{lang}}info.dataCreateddSuccessfully' }))
                if (this.props.updateFrames) {
                    this.props.updateFrames(fetchResult.info)
                }
                this.addModal.close()
                if (cb) cb()
            })
        }
    }


    handleTaskListName = (e) => {
        this.setState({ name: e.target.value })
    }
    render() {

        let colors = this.props.colors

        return (
            <div>

                <div ref={el => this.plusBut = el} className="" onClick={(e) => { e.stopPropagation(); this.plusFixedView.showView() }}>
                    {this.props.fullSize ? (
                        <button className='py-2 px-2 w-100 flexc hover-gray-no-filter br-5  transition-all'>
                            <div className='flexcc' style={{ width: 22 }}>
                                <img className="transition-all" src={importedIcons.plus} height={22} alt='' />
                            </div>
                            <div className='mld-3'>
                                <p className="font-size-12 main-c3 text-semibold " style={{}}>{translate("New Frame")}</p>
                            </div>
                        </button>
                    ) : (
                        <button className='br-20 mx-1 flexcc' style={{ background: '#eee' }}>
                            <img className={"transition  "} width={18} src={importedIcons.plus} alt='' />
                        </button>
                    )}
                </div>

                {this.state.show && (
                    <FixedView width={this.props.width} zIndex={10} ref={el => this.plusFixedView = el} nodeRef={this.plusBut} xOffset={this.props.fullSize ? -225 : (this.props.language == 'fa' ? 215 : -20)} bottomOffset={this.props.fullSize ? -7 : 0} topOffset={this.props.fullSize ? -30 : 0} maxWidth={260} >
                        <div className='bg-white br-10 p-1 shadow-3 sc-gray2'>
                            <StagesManager ref={el => this.stageManager = el} height={'100%'} fast={true}>
                                <div width={this.props.width} isLoading={this.props.isLoading} stage={0} stageName={'ّfile'} className=' p-1 sc-gray2' style={{ maxHeight: '350px', overflowY: 'auto', }}>

                                    <div className='mb-2' >
                                        <IntractionActionsList onClick={() => this.newFrame('collection')} language={this.props.language} data={{ title: "{{lang}}Flexible Collection", icon: '/assets/icons/applets/database.png' }} />
                                    </div>

                                    {this.props.type == 'frame' && (
                                        <div className='mb-2 pt-2' style={{ borderTop: "1px solid #eee" }}>
                                            {/* <IntractionActionsList onClick={() => this.openNameModal('collection', 'tasklist')} language={this.props.language} data={{ title: "{{lang}}Flexible Collection", icon: '/assets/icons/applets/database.png' }} /> */}
                                            <IntractionActionsList onClick={() => this.newFrame('project')} language={this.props.language} data={{ title: "{{lang}}Task project", icon: '/assets/icons/applets/tasking.png' }} />
                                            <IntractionActionsList onClick={() => this.newFrame('drive')} language={this.props.language} data={{ title: "{{lang}}Drive module", icon: '/assets/icons/applets/drive.png' }} />
                                            <IntractionActionsList onClick={() => this.newFrame('messenger')} language={this.props.language} data={{ title: "{{lang}}Messenger module", icon: '/assets/icons/portals/chat (2).png' }} />
                                            <IntractionActionsList onClick={() => this.newFrame('inquiry')} language={this.props.language} data={{ title: "{{lang}}Inquiry module", icon: '/assets/icons/applets/inquiry.png' }} />
                                            <IntractionActionsList onClick={() => this.newFrame('calendar')} language={this.props.language} data={{ title: "{{lang}}Calendar module", icon: '/assets/icons/applets/inquiry.png' }} />
                                            <IntractionActionsList onClick={() => this.newFrame('collection', 'developer')} language={this.props.language} data={{ title: "{{lang}}Developer module", icon: '/assets/icons/applets/inquiry.png' }} />
                                            <IntractionActionsList onClick={() => this.newFrame('rooms')} language={this.props.language} data={{ title: "{{lang}}Room module", icon: '/assets/icons/applets/inquiry.png' }} />
                                            <IntractionActionsList onClick={() => this.newFrame('relations')} language={this.props.language} data={{ title: "{{lang}}Relations module", icon: '/assets/icons/applets/inquiry.png' }} />

                                        </div>
                                    )}
                                    {this.props.type == 'task' && (
                                        <div className='mb-2 pt-2'>
                                            <IntractionActionsList onClick={() => this.newFrame('collection', 'tasklist')} language={this.props.language} data={{ title: "{{lang}}Tasks", icon: importedIcons.tasking }} />
                                            <IntractionActionsList onClick={() => this.newFrame('collection', 'planner')} language={this.props.language} data={{ title: "{{lang}}Planner", icon: importedIcons.planner }} />
                                            <IntractionActionsList onClick={() => this.newFrame('recordClassifier', 'sprint')} language={this.props.language} data={{ title: "{{lang}}Sprints", icon: importedIcons.sprint }} />
                                            <IntractionActionsList onClick={() => this.newFrame('page', 'page')} language={this.props.language} data={{ title: "{{lang}}Page", icon: importedIcons.pages }} />
                                        </div>
                                    )}
                                    <div className='pt-2' style={{ borderTop: "1px solid #eee" }}>
                                        <IntractionActionsList onClick={() => this.openNameModal('page', 'page')} language={this.props.language} data={{ title: "{{lang}}Page", icon: '/assets/icons/applets/notebook.png' }} />
                                        <IntractionActionsList onClick={() => this.openNameModal('page', 'dashboard')} language={this.props.language} data={{ title: "{{lang}}Dashboard", icon: '/images/icons/gaming-video.png' }} />
                                        <IntractionActionsList onClick={() => this.openNameModal('folder', 'folder')} language={this.props.language} data={{ title: "{{lang}}Folder", icon: importedIcons.folder }} />

                                        <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}Document", icon: importedIcons.document }} />
                                        <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}Whiteboard", icon: importedIcons.whiteBoard }} />
                                    </div>
                                </div>
                            </StagesManager>
                        </div>
                    </FixedView>
                )}


                <div onClick={(e) => e.stopPropagation()}>

                    <Modal ref={el => this.addModal = el} maxWidth={400}>
                        <div className="d-flex flex-column p-5 br-15 bg-white">
                            <p className='text-semibig text-bold'>{translate(`Create ${this.state.mode}`)}</p>
                            {this.state.mode == 'folder' && (
                                <p className='text-small mt-2'>{translate("Folders can be used for better categorization of different modules")}</p>
                            )}

                            {this.state.mode == 'dashboard' && (
                                <p className='text-small mt-2'>{translate("You can create a new dashboard")}</p>
                            )}

                            {this.state.mode == 'page' && (
                                <p className='text-small mt-2'>{translate("You can create a new page")}</p>
                            )}


                            <div className='mt-4 flexc'>
                                <input ref={(el) => this.nameInput = el} className='modern-input3 mrd-3 w-100 text-semibold px-3' style={{ borderRadius: '30px' }} value={this.state.name} onChange={(e) => this.handleTaskListName(e)} placeholder={translate("Folder name ...")} />

                                <ButtonAnimated
                                    iconwidth='24px'
                                    onClick={this.addClicked}
                                    title={translate("Create")}
                                    icon='/assets/icons/plus-white.svg'
                                    textColor={colors?.textColor}
                                    invert={colors?.iconInvert}
                                    bg={colors?.background ?? '#eee'}
                                />

                            </div>
                        </div>
                    </Modal>
                </div>

            </div >
        )
    }
}
